import { render, staticRenderFns } from "./addDepartmentModal.vue?vue&type=template&id=659350c1&scoped=true"
import script from "./addDepartmentModal.vue?vue&type=script&lang=js"
export * from "./addDepartmentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659350c1",
  null
  
)

export default component.exports